module.exports = __webpack_public_path__ + "static/media/deadly-15.1bc77ba8.png";